import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import TextIconCollection from '../../Core/TextIconCollection';
import Image from '../../Core/Image';

export const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
`;

export const Block = styled.div`
  display: flex;
  width: 100%;

  @media only screen and (min-width: 500px) {
    width: 45%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 30%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 25%;
  }

  &.left {
    text-align: left;
    order: 1;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      order: 0;
    }
  }

  &.right {
    text-align: left;
    order: 2;

    @media only screen and (min-width: 500px) {
      text-align: right;
    }
  }
`;

export const Features = styled(TextIconCollection)`
  display: flex;
  flex-wrap: wrap;

  li {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 0 2rem;

    &[data-aos='fade-left'] {
      transform: translate3d(30px, 0, 0);
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0 0 2.75rem;
    }

    ${Block}.left & {
      align-items: flex-start;
    }

    ${Block}.right & {
      align-items: flex-start;

      @media only screen and (min-width: 500px) {
        align-items: flex-end;
      }
    }

    h3 {
      margin-bottom: 0.75rem;
      font-size: 1.25rem;
      line-height: 1.5rem;

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        margin-bottom: 1rem;
        font-size: 1.75rem;
        line-height: 2.25rem;
      }
    }

    p {
      font-size: 1rem;
      line-height: 1.375rem;
      display: block;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 0.875rem;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1.125rem;
        line-height: 1.5rem;
      }
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  order: 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    order: 1;
    width: 35%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 40%;
  }

  h2 {
    color: ${themeGet('colors.pc-red', '#E1251B')};
    font-size: 2.25rem;
    line-height: 3rem;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 4.5rem;
      line-height: 4.875rem;
    }
  }
`;

export const Img = styled(Image)`
  margin: 15px auto;
  width: 100%;
  max-width: 215px;
  object-fit: contain;
  object-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 0 4.375rem;
    max-width: 260px;
    display: block;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 400px;
    min-width: auto;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin-bottom: 2rem;
`;

export const CopyWrapper = styled.div`
  margin: 1rem 0 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 2rem 0;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: -15px;

  a,
  button {
    margin: 15px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
